import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { StyleguideModule } from '@woolworthsnz/styleguide';
import {
	AddOneCardComponent,
	AddressAutocompleteComponent,
	AddressCaptureComponent,
	AutocompleteComponent,
	DetailedSelectionTileComponent,
	DobInputComponent,
	DropdownComponent,
	EmailPasswordInputComponent,
	FieldsetComponent,
	FormComponent,
	FormErrorComponent,
	FormHelpTextComponent,
	FormOptionalTextComponent,
	CustomFormComponent,
	InputComponent,
	InputErrorComponent,
	InputWithButtonComponent,
	InputWithIconButtonComponent,
	ManualAddressComponent,
	PasswordInputComponent,
	RadioGroupComponent,
	SelectComponent,
	SelectionTileComponent,
	FlexibleSelectionTileComponent,
	SelectOptionComponent,
	SuburbAutocompleteComponent,
	SwitchComponent,
	TimeslotSelectionComponent,
	ValidatedAddressComponent,
} from './components';
import { AutoFocusDirective, InputAccessorDirective, InvalidTypeDirective } from './directives';
import { FormService } from './services';

const components = [
	AddOneCardComponent,
	AddressCaptureComponent,
	AddressAutocompleteComponent,
	AutocompleteComponent,
	DetailedSelectionTileComponent,
	DobInputComponent,
	DropdownComponent,
	EmailPasswordInputComponent,
	FieldsetComponent,
	FormComponent,
	CustomFormComponent,
	FormErrorComponent,
	FormHelpTextComponent,
	FormOptionalTextComponent,
	InputComponent,
	InputErrorComponent,
	InputWithButtonComponent,
	InputWithIconButtonComponent,
	ManualAddressComponent,
	PasswordInputComponent,
	RadioGroupComponent,
	SuburbAutocompleteComponent,
	ValidatedAddressComponent,
	SelectComponent,
	SelectOptionComponent,
	SelectionTileComponent,
	FlexibleSelectionTileComponent,
	SwitchComponent,
	TimeslotSelectionComponent,
];

const directives = [AutoFocusDirective, InvalidTypeDirective, InputAccessorDirective];
@NgModule({
	exports: [...components, ...directives],
	imports: [
		CommonModule,
		OverlayModule,
		PortalModule,
		ReactiveFormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode' }),
		StyleguideModule,
		...components,
		...directives,
	],
	providers: [FormService],
})
export class FormModule {}
